import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Skeleton } from 'antd'
import PageLayout from '@BUP/components/Layout/Page'
import { getFetcher } from '@BUP/services/Axios'
import AlertComponent from '@BUP/components/Generics/Alert'
import { ComplaintDescriptions } from '@BUP/components/complaint/descriptions'
import { useTranslation } from 'react-i18next'

export function LogbookShowComplaintPage () {
  const i18n = useTranslation()
  const { complaintId } = useParams()
  const { data, isLoading, error, mutate } = useSWR(`/complaints/${complaintId}?include=complaintEntries`, getFetcher, {
    errorRetryCount: 3,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })
  const content = error
    ? <AlertComponent type='error' message={i18n.t('common.resources.generic.actions.any.failure', { context: 'try-again' })} />
    : <ComplaintDescriptions complaint={data} mutate={mutate} isLoading={isLoading} />
  return (
    <PageLayout backButton pageName={i18n.t('common.resources.complaint.label', { count: 1 })}>
      <Skeleton loading={isLoading}>
        {content}
      </Skeleton>
    </PageLayout>
  )
}
